import { Button, Snackbar, TableRow, Toast } from "@mcleod/components";
import { Api, ModelRow } from "@mcleod/core";
import { PlanningTableRowActionProps } from "@mcleod/general/src/planning/PlanningTableRowAction";
import { OrderPlanningRowAction, ReasonMap } from "./OrderPlanningRowAction";
import { LMECompanySettings } from "@mcleod/general";

export class RowActionCancelSentLoad extends OrderPlanningRowAction {
    public findNearOn: boolean = false;

    get findNearOnColor() {
        return "success";
    }

    override isConditionallyVisible(): boolean {
        return true;
    }

    override checkVisibility(modelRow: ModelRow): boolean {
        const visible = modelRow?.getBoolean("allow_cancel_send_load") ?? false;

        this.getButton().visible = visible;
        this.getButton().enabled = visible;

        return visible;
    }

    override getButton(): Button {
        return this.toolPanel.buttonCancelSentLoad;
    }

    override getButtonId(): string {
        return "buttonCancelSentLoad";
    }

    override getFieldsUsedInThisFile(): string[] {
        return [];
    }

    override async actionValidateSelection(selectedRows: ModelRow[], reasonMap: ReasonMap): Promise<void> {
        const modelRow = selectedRows[0];
        const allowCancelSendLoad = modelRow.getBoolean("allow_cancel_send_load");
        const isTransferredToDriver = modelRow.getBoolean("xmitted2driver");

        if (!allowCancelSendLoad || !isTransferredToDriver) {
            this.addReason(reasonMap, "", "Load is not eligible to be cancelled.");
        }
    }

    override async execute(props: PlanningTableRowActionProps) {
        const selectedRows = props.selectedRows;
        const modelRow = selectedRows[0]?.data as ModelRow; // will be changed to multi-select later
        if (modelRow == null)
            return;

        this.cancelSentLoad(selectedRows);
    }

    async cancelSentLoad(selectedRows: TableRow[]) {
        Api.post("lme/dispatch/asset/cancel-zmit-load", { movement_id: selectedRows[0].data.get("movement_id")})
        .catch(e => {
            Snackbar.showWarningSnackbar(e.messages[0]);
        });
    }

    static override canShowAction(): boolean {
        return LMECompanySettings.get().mobile_comm_licensed_active
    }
}
